import { MockOrderService } from '@gkn-ili/views/dist/mocks/order-service';
import FixtureKnuckle from '../fixtures/assembleKnuckle';

export const orderService = new MockOrderService(
  FixtureKnuckle.order,
  FixtureKnuckle.routingItems,
  FixtureKnuckle.routingItemSteps,
  FixtureKnuckle.activityGroups,
  FixtureKnuckle.activities,
  FixtureKnuckle.modelFile,
);
